import handlersTreeMixin from "./handlersTreeMixin";
import handleRequestErrorMixin from "../views/handleRequestErrorMixin";
import h from "../services/h";
import utils from "../services/utils";
import constants from "../constants";
import nextStepInfoViewService from "../services/nextStepInfoViewService";
import userDeptRoleViewService from "../services/userDeptRoleViewService";
import departmentService from "../services/departmentService";

export default {
  mixins: [handleRequestErrorMixin, handlersTreeMixin],
  data() {
    return {
      DEPARTMENT_TREE: constants.DEPARTMENT_TREE,
      DEPARTMENT: constants.DEPARTMENT,
      PROCESS_TYPE: constants.PROCESS_TYPE,

      selectedHandlersData: [],
      processType: null,
      query: null,
      selectedTagData: null,
      form: {
        note: null,
        isAutoAssignTask: false
      }
    };
  },

  computed: {
    userDeptRoleId() {
      return this.$route.params.userDeptRoleId;
    }
  },

  watch: {},

  methods: {
    selectTags(event, defaultProcessType) {
      this.selectedTagData = event;
      h.each(this.roots, root =>
        this.markCheckedForSelectedTags(root, defaultProcessType)
      );
    },

    filterTree(value, data) {
      switch (data.nodeType) {
        case constants.DEPARTMENT_TREE.NODE_TYPE.DEPT:
          return utils.like(data.department.deptName, this.query);
        case constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE:
          return utils.filterUserDeptRoleView(this.query, data.userDeptRole);
        default:
          return false;
      }
    },

    removeFromSelectedHandlersData(item) {
      this.$set(item.data, "checked", false);
      this.addOrRemoveToSelectedHandlers(
        item.data,
        constants.PROCESS_TYPE.CHUTRI
      );
      this.updateCheckedForParent(item.data);
      this.refreshProcessType();
    },

    isOnlyProccessTypeChecked(processType) {
      return (
        this.selectedHandlersData &&
        this.selectedHandlersData.length &&
        !h.exists(
          this.selectedHandlersData,
          item => item.processType !== processType
        )
      );
    },

    refreshProcessType() {
      if (this.isOnlyProccessTypeChecked(constants.PROCESS_TYPE.CHUTRI)) {
        this.processType = constants.PROCESS_TYPE.CHUTRI;
      } else if (
        this.isOnlyProccessTypeChecked(constants.PROCESS_TYPE.NHANDEBIET)
      ) {
        this.processType = constants.PROCESS_TYPE.NHANDEBIET;
      } else if (
        this.isOnlyProccessTypeChecked(constants.PROCESS_TYPE.PHOIHOP)
      ) {
        this.processType = constants.PROCESS_TYPE.PHOIHOP;
      } else {
        this.processType = null;
      }
    },

    checkAllProcessType() {
      h.each(this.selectedHandlersData, item =>
        this.$set(item, "processType", this.processType)
      );
    },

    checkedChange(data, defaultProcessType) {
      let checked = data.checked;
      if (data.isHandlerNode) {
        let nodeType = data.nodeType;
        switch (nodeType) {
          case constants.DEPARTMENT_TREE.NODE_TYPE.DEPT:
          case constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE:
            this.addOrRemoveToSelectedHandlers(
              data,
              defaultProcessType || constants.PROCESS_TYPE.CHUTRI
            );
            break;
          default:
            break;
        }
      } else {
        this.checkedAllChildren(data, checked, defaultProcessType);
      }
      this.updateCheckedForParent(data);
      this.refreshProcessType();
    },

    checkedAllChildren(data, checked, defaultProcessType) {
      h.each(data.children, child => {
        let checkedState = child.checked || false;
        if (checkedState !== checked) {
          this.$set(child, "checked", checked);
          this.checkedChange(child, defaultProcessType);
        }
      });
    },

    updateCheckedForParent(data) {
      let parent = data.parent;
      if (!parent || parent.isHandlerNode) return;
      let currentCheckedState = parent.checked;
      let newCheckedState = !h.exists(parent.children, child => !child.checked);
      if (currentCheckedState !== newCheckedState) {
        this.$set(parent, "checked", newCheckedState);
        this.updateCheckedForParent(parent);
      }
    },

    addOrRemoveToSelectedHandlers(data, processType) {
      let checked = data.checked;
      let index = h.indexOf(
        this.selectedHandlersData,
        item => item.data === data
      );
      if (checked) {
        if (index === -1)
          this.selectedHandlersData.push({
            data: data,
            processType: processType || constants.PROCESS_TYPE.CHUTRI
          });
      } else {
        this.selectedHandlersData.splice(index, 1);
      }
    },

    loadNextStepsInfo(flowId, stepId) {
      return nextStepInfoViewService
        .nextSteps(flowId, stepId)
        .then(response => response.data);
    },

    loadHandlers(stepId, nextSteps) {
      let nextStepsCaNhan = h.findAll(
        nextSteps,
        nextStep => nextStep.stepType === constants.STEP.STEP_TYPE.CANHAN
      );
      let nextStepsDonVi = h.findAll(
        nextSteps,
        nextStep => nextStep.stepType === constants.STEP.STEP_TYPE.DONVI
      );
      return Promise.all([
        this.findAllActiveUserDeptRoleForStepInfos(stepId, nextStepsCaNhan),
        this.findAllActiveDepartmentForStepInfos(nextStepsDonVi)
      ]).then(results => {
        let userDeptRoles = [];
        h.each(
          results[0],
          userDeptRoles_ =>
            userDeptRoles_ && userDeptRoles.push(...userDeptRoles_)
        );
        let userDeptRolesSet = [];
        h.each(
          userDeptRoles,
          userDeptRole =>
            h.indexOf(userDeptRolesSet, item => item.id === userDeptRole.id) ===
              -1 && userDeptRolesSet.push(userDeptRole)
        );
        let departments = results[1];
        this.buildHandlerOrderMap({
          userDeptRoles: userDeptRolesSet,
          departments,
          nextSteps
        });

        // if (userDeptRolesSet) {
        //   userDeptRolesSet.sort((item1, item2) =>
        //     utils.compareUserDeptRoleView(item1, item2)
        //   );
        // }
        //
        // if (departments) {
        //   departments.sort((item1, item2) =>
        //     utils.compareDepartment(item1, item2)
        //   );
        // }

        return [userDeptRolesSet, departments];
      });
    },

    markCheckedForSelectedTags(data, defaultProcessType) {
      h.each(data.children, child =>
        this.markCheckedForSelectedTags(child, defaultProcessType)
      );
      if (data.isHandlerNode) {
        let nodeType = data.nodeType;
        let selectedHandler;
        switch (nodeType) {
          case constants.DEPARTMENT_TREE.NODE_TYPE.DEPT:
            let department = data.department;
            selectedHandler = h.find(
              this.selectedTagData,
              item =>
                item.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.DEPT &&
                department.id === item.department.id
            );
            break;
          case constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE:
            let userDeptRole = data.userDeptRole;
            selectedHandler = h.find(
              this.selectedTagData,
              item =>
                item.nodeType ===
                  constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE &&
                userDeptRole.userId === item.handler.userView.userId &&
                userDeptRole.deptId === item.handler.userView.deptId &&
                userDeptRole.roleId === item.handler.userView.roleId
            );
            break;
          default:
            break;
        }
        if (selectedHandler) {
          this.$set(data, "checked", true);
          this.addOrRemoveToSelectedHandlers(
            data,
            defaultProcessType || selectedHandler.processType
          );
        }
      } else {
        let isExistsDeptInSelectedHashTag = false;
        if (data.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.DEPT) {
          isExistsDeptInSelectedHashTag = h.exists(
            this.selectedTagData,
            item =>
              item.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.DEPT &&
              data.department.id === item.department.id
          );
        }

        if (isExistsDeptInSelectedHashTag) {
          this.$set(data, "checked", true);
          this.checkedAllChildren(
            data,
            true,
            this.defaultProcessType || constants.PROCESS_TYPE.NHANDEBIET
          );
        } else {
          let isAllChildNodesChecked = !h.exists(
            data.children,
            child => !child.checked
          );
          this.$set(data, "checked", isAllChildNodesChecked);
        }
      }
    },

    findAllActiveUserDeptRoleForStepInfo(nextStepCaNhan) {
      return userDeptRoleViewService
        .findAllActiveForStepInfo(nextStepCaNhan.vbStepInfoId)
        .then(response => response.data);
    },

    findAllActiveUserDeptRoleForStepInfos(stepId, nextStepsCaNhan) {
      return nextStepsCaNhan && nextStepsCaNhan.length
        ? Promise.all(
            h.collect(nextStepsCaNhan, nextStepCaNhan =>
              this.findAllActiveUserDeptRoleForStepInfo(nextStepCaNhan)
                //filter de tranh TH tu chuyen cho chinh minh;
                .then(userDeptRoles =>
                  nextStepCaNhan.id === stepId
                    ? h.findAll(
                        userDeptRoles,
                        userDeptRole => userDeptRole.id !== this.userDeptRoleId
                      )
                    : userDeptRoles
                )
            )
          )
        : Promise.resolve([]);
    },

    findAllActiveDepartmentForStepInfos(nextStepsDonVi) {
      let nextStepsDonViDeptIds = h.collect(
        nextStepsDonVi,
        nextStepDonVi => nextStepDonVi.deptId
      );
      return nextStepsDonViDeptIds && nextStepsDonViDeptIds.length
        ? departmentService
            .findAllByIdIn(
              nextStepsDonViDeptIds,
              constants.DEPARTMENT.STATUS.ACTIVE
            )
            .then(response => response.data)
        : Promise.resolve([]);
    },

    getNodeLabel(node) {
      return utils.getNodeLabelForHandlersTree(node);
    },

    validate() {
      if (!this.selectedHandlersData || !this.selectedHandlersData.length) {
        this.message(
          "Thông báo",
          "Danh sách chuyển xử lý chưa được chọn",
          "error",
          4000
        );
        return false;
      }
      return true;
    },

    findNextStepMatchWithHandler(data, nextSteps) {
      let nodeType = data.nodeType;
      if (nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE) {
        let userDeptRole = data.userDeptRole;
        return this.findNextStepMatchWithUserDeptRoleHandler(
          userDeptRole,
          nextSteps
        );
      } else if (nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.DEPT) {
        let department = data.department;
        return this.findNextStepMatchWithDepartmentHandler(
          department,
          nextSteps
        );
      }
      return null;
    },

    findNextStepMatchWithDepartmentHandler(department, nextSteps) {
      return h.find(
        nextSteps,
        nextStep =>
          nextStep.stepType === constants.STEP.STEP_TYPE.DONVI &&
          (!nextStep.deptId || nextStep.deptId === department.id)
      );
    },

    findNextStepMatchWithUserDeptRoleHandler(userDeptRole, nextSteps) {
      return h.find(nextSteps, nextStep =>
        nextStepInfoViewService.isMatchingWithUserDeptRole(
          userDeptRole,
          nextStep
        )
      );
    },

    findStepIdForHandler(data, stepId, nextSteps) {
      let step = this.findNextStepMatchWithHandler(data, nextSteps);
      return step ? step.id : null;
    },

    buildHandlerOrderMap({ userDeptRoles, departments, nextSteps }) {
      this.handlerOrderMap = {};
      h.each(userDeptRoles, userDeptRole => {
        let nextStep = this.findNextStepMatchWithUserDeptRoleHandler(
          userDeptRole,
          nextSteps
        );
        if (nextStep && nextStep.order)
          this.handlerOrderMap[userDeptRole.id] = nextStep.order;
      });
      h.each(departments, department => {
        let nextStep = this.findNextStepMatchWithDepartmentHandler(
          department,
          nextSteps
        );
        if (nextStep && nextStep.order)
          this.handlerOrderMap[department.id] = nextStep.order;
      });
      // console.log(JSON.stringify(this.handlerOrderMap));
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/cxlVbdenCommonMixin.js